<page-title
  text="BitOasis | Careers"
  i18n-text="@@pageTitle.careers"
></page-title>

<site-layout class="white full">
  <!-- Hero Section -->
  <section class="hero-section">
    <h1 class="title" i18n="@@careers.hero.title">
      Join the <span class="text-success">Crypto Revolution</span><br />
      shaping the region
    </h1>

    <p class="desc" i18n="@@careers.hero.subheadline">
      {{ subHeadline }}
    </p>

    <button
      class="btn btn-success"
      (click)="scrollToSection('khembedjobs')"
      i18n="@@careers.hero.cta"
    >
      Find Open Jobs
    </button>
  </section>

  <!-- Our Principles -->
  <section class="principles-section card-bg">
    <h2 class="title" i18n="@@careers.principles.title">Our Principles</h2>

    <div class="container">
      <div class="row g-4 align-items-stretch w-100 m-0">
        <div class="col-sm-6 col-lg-3">
          <div class="card border-0 card-hover h-100 d-flex flex-column">
            <div class="card-body flex-grow-1">
              <img
                src="assets/images/careers/costumer.webp"
                alt="costumer"
                width="80"
                height="80"
              />
              <h5 class="card-title" i18n="@@careers.principles.customerFirst">
                Customer First Action
              </h5>
            </div>
            <p class="card-text" i18n="@@careers.principles.customerFirst.desc">
              We put our customers at the heart of every decision, ensuring
              their needs guide our actions.
            </p>
          </div>
        </div>

        <div class="col-sm-6 col-lg-3">
          <div class="card border-0 card-hover h-100 d-flex flex-column">
            <div class="card-body flex-grow-1">
              <img
                src="assets/images/careers/thinker.webp"
                alt="thinker"
                width="80"
                height="80"
              />
              <h5 class="card-title" i18n="@@careers.principles.execution">
                Outcome Oriented Execution
              </h5>
            </div>
            <p class="card-text" i18n="@@careers.principles.execution.desc">
              We don't just work hard, we work smart, delivering measurable
              impact with every project.
            </p>
          </div>
        </div>

        <div class="col-sm-6 col-lg-3">
          <div class="card border-0 card-hover h-100 d-flex flex-column">
            <div class="card-body flex-grow-1">
              <img
                src="assets/images/careers/collaboration.webp"
                alt="collaboration"
                width="80"
                height="80"
              />
              <h5 class="card-title" i18n="@@careers.principles.collaboration">
                Collaboration & Teamwork
              </h5>
            </div>
            <p class="card-text" i18n="@@careers.principles.collaboration.desc">
              Great ideas know no borders. We unite our skills and perspectives
              to build something bigger together.
            </p>
          </div>
        </div>

        <div class="col-sm-6 col-lg-3">
          <div class="card border-0 card-hover h-100 d-flex flex-column">
            <div class="card-body flex-grow-1">
              <img
                src="assets/images/careers/development.webp"
                alt="development"
                width="80"
                height="80"
              />
              <h5 class="card-title" i18n="@@careers.principles.ownership">
                Ownership Driven Growth
              </h5>
            </div>
            <p class="card-text" i18n="@@careers.principles.ownership.desc">
              We act like owners, taking initiative, embracing challenges, and
              turning them into opportunities to grow.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- BitOasis at a Glance -->
  <section class="glance-section bg-white">
    <h2 class="title" i18n="@@careers.glance.title">BitOasis at a Glance</h2>

    <div class="container">
      <div class="row g-4 align-items-stretch m-0">
        <div class="col-md-4 col-sm-6">
          <div
            class="card border-0 card-hover h-100 d-flex flex-column card-bg"
          >
            <div class="card-body flex-grow-1">
              <img
                src="assets/images/careers/employees.webp"
                alt="employees"
                width="80"
                height="80"
              />
              <h5 class="card-title" i18n="@@careers.glance.employees">
                110+ Employees
              </h5>
              <p class="desc" i18n="@@careers.glance.employees.desc">
                and growing every day
              </p>
            </div>
          </div>
        </div>

        <div class="col-md-4 col-sm-6">
          <div
            class="card border-0 card-hover h-100 d-flex flex-column card-bg"
          >
            <div class="card-body flex-grow-1">
              <img
                src="assets/images/careers/iso.webp"
                alt="iso"
                width="80"
                height="80"
              />
              <h5 class="card-title" i18n="@@careers.glance.iso">ISO 27001</h5>
              <p class="desc" i18n="@@careers.glance.iso.desc">Certified</p>
            </div>
          </div>
        </div>

        <div class="col-md-4 col-sm-6">
          <div
            class="card border-0 card-hover h-100 d-flex flex-column card-bg"
          >
            <div class="card-body flex-grow-1">
              <div class="d-flex gap-3">
                <img
                  src="assets/images/careers/vara.webp"
                  alt="vara"
                  width="80"
                  height="80"
                />
                <img
                  src="assets/images/careers/docker.webp"
                  alt="docker"
                  width="80"
                  height="80"
                />
              </div>
              <h5 class="card-title" i18n="@@careers.glance.licenses">
                Vara & CBB
              </h5>
              <p class="desc" i18n="@@careers.glance.licenses.desc">Licensed</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="container bg-white pt-5" dir="ltr">
    <div id="khembedjobs"></div>
  </section>

  <!-- Life at BitOasis -->
  <section class="life-section container bg-white">
    <h2 class="title" i18n="@@careers.life.title">
      Life at <span class="text-success">BitOasis</span>
    </h2>
    <p class="desc" i18n="@@careers.life.desc">
      At BitOasis, we thrive on diversity, teamwork, and a shared mission,
      building trusted crypto solutions and empowering the region through
      innovation, ownership, and meaningful impact every day.
    </p>

    <div class="container">
      <div class="row g-4 justify-content-center mt-5 mx-0">
        <div class="col-md-4 col-sm-6 py-0">
          <div class="life-card card text-white border-0">
            <img
              src="assets/images/careers/life-uae.webp"
              class="card-img"
              alt="Life at BitOasis UAE"
            />
            <div class="card-img-overlay d-flex align-items-start">
              <h3 class="fw-bold mb-0 d-flex flex-column gap-1">
                <img
                  src="assets/images/careers/uae-flag.webp"
                  alt="UAE Flag"
                  class="flag-icon"
                />
                <span i18n="@@careers.life.uae">UAE</span>
              </h3>
            </div>
          </div>
        </div>

        <div class="col-md-4 col-sm-6 py-0">
          <div class="life-card card text-white border-0">
            <img
              src="assets/images/careers/life-bahrain.webp"
              class="card-img"
              alt="Life at BitOasis Bahrain"
            />
            <div class="card-img-overlay d-flex align-items-start">
              <h3 class="fw-bold mb-0 d-flex flex-column gap-1">
                <img
                  src="assets/images/careers/bahrain-flag.webp"
                  alt="Bahrain Flag"
                  class="flag-icon"
                />
                <span i18n="@@careers.life.bahrain">Bahrain</span>
              </h3>
            </div>
          </div>
        </div>

        <div class="col-md-4 col-sm-6 py-0">
          <div class="life-card card text-white border-0">
            <img
              src="assets/images/careers/life-jordan.webp"
              class="card-img"
              alt="Life at BitOasis Jordan"
            />
            <div class="card-img-overlay d-flex align-items-start">
              <h3 class="fw-bold mb-0 d-flex flex-column gap-1">
                <img
                  src="assets/images/careers/jordan-flag.webp"
                  alt="Jordan Flag"
                  class="flag-icon"
                />
                <span i18n="@@careers.life.jordan">Jordan</span>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div
    class="kh-text-center kh-py-3 kh-footer-content kh-w-100 kh-d-flex kh-align-items-center kh-justify-content-center"
  >
    <span class="kh-text-secondary kh-align-middle kh-pr-2 kh-font-normal">
      © <span id="year">2025</span> Keka Hire. Powered by
    </span>
    <a href="https://www.keka.com" target="_blank">
      <img
        width="50"
        src="https://cdn.keka.com/shared/branding/logo/keka-logo-black.svg"
    /></a>
  </div>
</site-layout>

<site-footer></site-footer>
